import React, { useEffect, useRef, useState } from "react";
import "./Summary.css";
import { Image } from "react-bootstrap";
import { Container } from "react-bootstrap";

import { Tooltip } from "primereact/tooltip";
import { FaMotorcycle, FaCar, FaTruck } from "react-icons/fa";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import yokohamaMini from "../../assets/images/TyreBrandLogos/yokohama_mini_2.png";
import miniDot from "../../assets/images/mini_dot.png";
import noProductFoundImage from "../../assets/images/product-not-found.png";
import servicePointImg from "../../assets/images/selected-service-point-img-mini.png";
import walletIcon from "../../assets/images/wallet-icon.png";
import dicountIcon from "../../assets/images/discount-icon.png";
import { FaPlus, FaRegEdit } from "react-icons/fa";
import { Checkbox } from "primereact/checkbox";
import useCartAPI from "../../api/useCartAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { IoCalendarOutline, IoClose } from "react-icons/io5";
import useUserAPI from "../../api/useUserAPI";
import dummyCarImg from "../../assets/images/dummy-car-img.png";
import checkIcon from "../../assets/images/check.png";
import useVehicleAPI from "../../api/useVehicleAPI";
import useHeroAPI from "../../api/useHeroAPI";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import useOrderAPI from "../../api/useOrderAPI";
import { RadioButton } from "primereact/radiobutton";
import dummyCarImg2 from "../../assets/images/dummyCarImage.png";
import { resetCart, updateCartQuantity } from "../../features/cart/cartSlice";
import { useDispatch } from "react-redux";
import vehicleText from "../../assets/images/vehicleText.png";
import { format } from "date-fns";
import useCouponAPI from "../../api/useCouponAPI";
import useWalletAPI from "../../api/useWalletAPI";
import AppSkeleton from "../../components/AppSkeleton/AppSkeleton";
import { MdEdit } from "react-icons/md";

interface ProductDetails {
  product_id: number;
  product_name: string;
  product_price: number;
  product_offer_price: number;
  category: Category;
  make?: Entity;
  model?: Entity;
  variant?: Entity;
}

interface Category {
  predefined_id: number;
  name: string;
  code: string;
  entity_type: string;
  field1: string;
  field2?: string;
  field3?: string;
  is_delete: string;
  is_deactivate: string;
  url?: string;
  thumbnail?: string;
}

interface Entity {
  predefined_id?: number;
  name?: string;
  code?: string;
  entity_type?: string;
  field1?: string;
  field2?: string;
  field3?: string;
  is_delete: string;
  is_deactivate: string;
  url?: string;
  thumbnail?: string;
}

interface Item {
  cart_item_id: number;
  product_id: number;
  item_quantity: number;
  total_amount: number;
  discount?: number;
  is_wishList: boolean;
  created_by_id: number;
  created_date: string;
  product: ProductDetails;
}

interface Car {
  id: number;
  name: string;
  color: string;
  licensePlate: string;
  imageUrl: string;
  make: string;
  category?: {
    name?: string;
  };
  model: string;
  variant: string;
}

interface Address {
  detail_address: string;
  street_address: string;
  landmark: string;
  pincode: string;
}

interface OrderConfirmationDetails {
  orderId: string;
  paymentId: string;
  amount: string;
  serviceDate: string;
  serviceTime: string;
  vehicle: string;
}

const Summary = () => {
  const basePath = process.env.REACT_APP_BASE_PATH;
  const corporateAdminRole = "ROLE_CORPORATE_ADMIN";
  const corporateUserRole = "ROLE_CORPORATE_USER";
  const fleetUserRole = "ROLE_FLEET_USER";
  const fleetUserOwner = "ROLE_FLEET_OWNER";
  const customerRole = "ROLE_CUSTOMER";

  const {
    cartList,
    cartRemoveItem,
    cartSummery,
    cartSummeryUsingWallet,
    getPaymentLink,
    getPaymentStatus,
  } = useCartAPI();

  const { getWalletBalance } = useWalletAPI();
  const { getVehicleList, saveVehicle } = useVehicleAPI();
  const { getUserAddress, saveUserAddress } = useUserAPI();
  const { predefinedFunc } = useHeroAPI();
  const { scheduleAppointment, saveOrderAPI } = useOrderAPI();
  const { getCouponList } = useCouponAPI();
  const [pincodeError, setPincodeError] = useState("");
  const [loader, setLoader] = useState(false);
  const [countdown, setCountdown] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const toast = useRef<Toast>(null);

  const [items, setItems] = useState<Item[]>([]);
  const [selectedServicePoint, setSelectedServicePoint] = useState() as any;
  const [pickedDate, setPickedDate] = useState([]) as any;
  const [pickedTime, setPickedTime] = useState([]) as any;
  const [walletBalance, setWalletBalance] = useState([]) as any;
  const [selectedCarId, setSelectedCarId] = useState(null) as any;
  const [visible, setVisible] = useState(false);
  const [vehicleName, setVehicleName] = useState(null) as any;
  const [vehicleNumber, setVehicleNumber] = useState(null) as any;
  const [make, setMake] = useState(null) as any;
  const [models, setModels] = useState(null) as any;
  const [variant, setVariant] = useState(null) as any;
  const [category, setCategory] = useState(null) as any;
  const [typeId, setTypeId] = useState(null) as any;
  const [selectedCity, setSelectedCity] = useState(null) as any;
  const [selectedState, setSelectedState] = useState(null) as any;
  const [selectedCountry, setSelectedCountry] = useState(null) as any;
  const [makes, setMakes] = useState(null) as any;
  const [model, setModel] = useState(null) as any;
  const [variants, setVariants] = useState(null) as any;
  const [categories, setCategories] = useState(null) as any;
  const [typeIds, setTypeIds] = useState(null) as any;
  const [cityOptions, setCityOptions] = useState(null) as any;
  const [stateOptions, setStateOptions] = useState(null) as any;
  const [countryOptions, setCountryOptions] = useState(null) as any;
  const [submitted, setSubmitted] = useState(false) as any;
  const [cars, setCars] = useState<Car[]>([]);

  const [userIdState, setUserIdState] = useState<string>("");
  const [companyIdState, setCompanyIdState] = useState<string>("");
  const [servicePointId, setServicePointId] = useState<string>("");
  const [billingDetails, setBillingDetails] = useState([]) as any;

  const [useWalletBalance, setUseWalletBalance] = useState(false) as any;
  const [useDiscountCode, setUseDiscountCode] = useState(false) as any;
  const [showCouponDialog, setShowCouponDialog] = useState(false) as any;
  const [billingAddressesState, setBillingAddressesState] = useState([]) as any;
  const [shippingAddressesState, setShippingAddressesState] = useState(
    [],
  ) as any;
  const [billingAddresses, setBillingAddresses] = useState([]) as any;
  const [shippingAddresses, setShippingAddresses] = useState([]) as any;
  const [newBillingAddress, setNewBillingAddress] = useState([]) as any;
  const [newShippingAddress, setNewShippingAddress] = useState([]) as any;
  const [isChangingAddress, setIsChangingAddress] = useState(false);
  const [isChangingBillingAddress, setIsChangingBillingAddress] =
    useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState("");
  const [selectedShippingAddress, setSelectedShippingAddress] = useState("");
  const [selectedPickedDate, setSelectedPickedDate] = useState("");
  const [address, setAddress] = useState<Address>({
    detail_address: "",
    street_address: "",
    landmark: "",
    pincode: "",
  });
  const [allCouponList, setAllCouponList] = useState([]) as any;
  const [currentCouponCode, setCurrentCouponCode] = useState<string>("");
  const [hideWalletAndCoupon, setHideWalletAndCoupon] = useState(false) as any;
  const [makePaymentObject, setMakePaymentObject] = useState(null);
  const [newWindow, setNewWindow] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [userRole, setUserRole] = useState("") as any;
  const [loading, setLoading] = useState(false) as any;
  const [showOrderConfirmationDialog, setShowOrderConfirmationDialog] =
    useState(false);
  const [orderConfirmationDetails, setOrderConfirmationDetails] =
    useState<OrderConfirmationDetails>({
      orderId: "-",
      paymentId: "-",
      amount: "0.00",
      serviceDate: "-",
      serviceTime: "-",
      vehicle: "-",
    });

  const formatDateToString = (date: Date | null): string => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    return "";
  };

  const defaultAddressOptions = [
    { name: "Yes", key: "true" },
    { name: "No", key: "false" },
  ];

  const [isDefaultAddress, setIsDefaultAddress] = useState<
    (typeof defaultAddressOptions)[number] | null
  >(null);

  useEffect(() => {
    const servicePointData = location.state;
    setSelectedServicePoint(servicePointData?.selectedServicePointData[0]);
    setServicePointId(
      servicePointData?.selectedServicePointData[0].service_point_id,
    );
    setSelectedPickedDate(servicePointData?.pickedDateState);
    const date = new Date(servicePointData?.pickedDateState);
    const formattedDate = format(date, "do MMMM yyyy");
    setPickedDate(formattedDate);
    setPickedTime(servicePointData?.pickedTimeVar);

    handleCancel();
  }, []);

  useEffect(() => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");

    if (authTokens?.user?.roles) {
      if (authTokens?.user?.roles[0].code !== customerRole) {
        setHideWalletAndCoupon(true);
      }
      const userRole = authTokens?.user?.roles[0];
      if (userRole) setUserRole(userRole);
      if (
        authTokens?.user?.roles[0].code === corporateAdminRole ||
        authTokens?.user?.roles[0].code === corporateUserRole ||
        authTokens?.user?.roles[0].code === fleetUserOwner ||
        authTokens?.user?.roles[0].code === fleetUserRole
      ) {
        setUseWalletBalance(true);
      }
    }
  }, []);

  const fetchCartProducts = async () => {
    try {
      setLoader(true);

      const payload = {
        is_wishList: false,
      };

      const response: any = await cartList(payload);
      const mappedProducts = response?.data?.data.map((item: any) => ({
        id: String(item?.product_id ?? item?.service_id) ?? 0,
        name:
          item?.product?.product_name ??
          item?.service?.service_name ??
          "Not Available",
        prodPrice: String(item.total_amount),
        quantity: item.item_quantity,
        prodTotal: String(item.total_amount * item.item_quantity),
        cartItemId: item?.cart_item_id,
        brandImage:
          item?.product?.document_as_product?.[0]?.document?.file_path,
        productImage:
          item?.product?.document_as_product?.[0]?.document?.file_path,
      }));
      setItems(mappedProducts);
    } finally {
      setLoader(false);
    }
  };

  const fetchAddress = async () => {
    const authTokens: any = JSON.parse(
      localStorage.getItem("authTokens") || "{}",
    );
    const userId = authTokens.user?.id;
    setUserIdState(authTokens?.user?.id);
    setCompanyIdState(authTokens.user?.company_id);

    const walletBalanceResponse: any = await getWalletBalance(
      parseInt(authTokens.user?.company_id),
      parseInt(authTokens.user?.id),
    );

    if (
      walletBalanceResponse.status === 200 ||
      walletBalanceResponse.status === 201
    ) {
      if (walletBalanceResponse?.data?.balance >= 0) {
        setWalletBalance(walletBalanceResponse?.data?.balance);
      } else {
        setWalletBalance(0);
      }
    }

    const billingPayload = {
      user_id: userId,
      entity_type: "BILLING",
    };
    const shippingPayload = {
      user_id: userId,
      entity_type: "SHIPPING",
    };

    const billingResponse = await getUserAddress(billingPayload);
    // const shippingResponse = await getUserAddress(shippingPayload);

    if (
      billingResponse?.data.length > 0 &&
      !billingResponse?.data.some((address: any) => address?.is_default)
    ) {
      setSelectedBillingAddress(billingResponse?.data[0]?.address_id);
    }
    // if (
    //   shippingResponse?.data.length > 0 &&
    //   !shippingResponse?.data.some((address: any) => address?.is_default)
    // ) {
    //   setSelectedShippingAddress(shippingResponse?.data[0]?.address_id);
    // }

    if (billingResponse?.data.length === 1) {
      setBillingAddresses(billingResponse?.data || []);
      setBillingAddressesState(billingResponse?.data[0] || {});
    } else {
      const defaultBillingAddress = billingResponse?.data?.find(
        (address: any) => address?.is_default,
      );
      setBillingAddresses(billingResponse?.data || []);
      setBillingAddressesState(defaultBillingAddress);
    }
if (
      billingResponse?.data.length > 0 )
     {
      setSelectedBillingAddress(billingResponse?.data[0]?.address_id);
    }
    // if (shippingResponse?.data.length === 1) {
    //   setShippingAddresses(shippingResponse?.data || []);
    //   setShippingAddressesState(shippingResponse?.data[0] || {});
    // } else {
    //   const defaultShippingAddress = shippingResponse?.data?.find(
    //     (address: any) => address?.is_default,
    //   );
    //   setShippingAddresses(shippingResponse?.data || []);
    //   setShippingAddressesState(defaultShippingAddress);
    // }
  };
  const getVehicleIcon = (categoryName?: string) => {
    const category = categoryName?.toLowerCase();

    if (category?.includes("two wheeler")) {
      return <FaMotorcycle />;
    }

    if (category?.includes("car")) {
      return <FaCar />;
    }

    if (category?.includes("truck")) {
      return <FaTruck />;
    }

    return <FaCar />;
  };
  const fetchPredefinedList = async () => {
    const tyrePayload = {
      entity_type: "TYRE-TYPE",
    };
    const typeIdResponse = await predefinedFunc(tyrePayload);
    const typeIdData = typeIdResponse?.data?.data.map((child: any) => {
      return {
        name: child.name,
        code: child.predefined_id,
      };
    });
    setTypeIds(typeIdData);

    const categoryPayload = {
      entity_type: "CATEGORY",
    };
    const categoryPredefinedResponse = await predefinedFunc(categoryPayload);
    const categoryData = categoryPredefinedResponse?.data?.data.map(
      (child: any) => {
        return {
          name: child.name,
          code: child.predefined_id,
        };
      },
    );
    setCategories(categoryData);

    const statePredefinedPayload = {
      entity_type: "STATE",
    };
    const statePredefinedResponse = await predefinedFunc(
      statePredefinedPayload,
    );
    const statesData = statePredefinedResponse?.data?.data.map((child: any) => {
      return {
        name: child.name,
        code: child.predefined_id,
      };
    });
    setStateOptions(statesData);

    const countryPredefinedPayload = {
      entity_type: "COUNTRY",
    };
    const countryPredefinedResponse = await predefinedFunc(
      countryPredefinedPayload,
    );
    const countriesData = countryPredefinedResponse?.data?.data.map(
      (child: any) => {
        return {
          name: child.name,
          code: child.predefined_id,
        };
      },
    );

    setCountryOptions(countriesData);
  };

  const fetchDependentData = async () => {
    if (category !== null) {
      const makePredefinedPayload = {
        entity_type: "MAKE",
        parent_id: category ?? null,
      };
      const makePredefinedResponse = await predefinedFunc(
        makePredefinedPayload,
      );
      const makeData = makePredefinedResponse?.data?.data.map((child: any) => {
        return {
          name: child.name,
          code: child.predefined_id,
        };
      });
      setMakes(makeData);
    }

    if (make !== null) {
      const modelPredefinedPayload = {
        entity_type: "MODEL",
        parent_id: make ?? null,
      };
      const modelPredefinedResponse = await predefinedFunc(
        modelPredefinedPayload,
      );
      const modelData = modelPredefinedResponse?.data?.data.map(
        (child: any) => {
          return {
            name: child.name,
            code: child.predefined_id,
          };
        },
      );
      setModels(modelData);
    }
    if (model !== null) {
      const variantPredefinedPayload = {
        entity_type: "VARIANT",
        parent_id: model ?? null,
      };
      const variantPredefinedResponse = await predefinedFunc(
        variantPredefinedPayload,
      );
      const variantData = variantPredefinedResponse?.data?.data.map(
        (child: any) => {
          return {
            name: child.name,
            code: child.predefined_id,
          };
        },
      );
      setVariants(variantData);
    }
  };

  const fetchCitiesData = async () => {
    const cityPredefinedPayload = {
      entity_type: "CITY",
      parent_id: selectedState,
    };
    const cityPredefinedResponse = await predefinedFunc(cityPredefinedPayload);

    if (selectedState) {
      const citiesData = cityPredefinedResponse?.data?.data.map(
        (child: any) => {
          return {
            name: child.name,
            code: child.predefined_id,
          };
        },
      );

      setCityOptions(citiesData);
    }
  };

  useEffect(() => {
    fetchCitiesData();
  }, [selectedState]);

  useEffect(() => {
    if (category !== null || make !== null || model !== null) {
      fetchDependentData();
    }
  }, [category, make, model]);

  const fetchCartSummary = async () => {
    const response: any = await cartSummery(
      currentCouponCode,
      useWalletBalance,
    );

    if (response?.response?.status === 400) {
      setCurrentCouponCode("");
      return toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.error}`,
      });
    }

    if (response.status === 200) {
      setBillingDetails(response?.data);
      setShowCouponDialog(false);
      if (currentCouponCode !== "") {
        setUseDiscountCode(true);
        return toast?.current?.show({
          severity: "success",
          summary: "Success",
          detail: `Coupon Applied`,
        });
      } else {
        setUseDiscountCode(false);
      }
    }
  };

  const fetchVehicleList = async () => {
    const authTokens: any = JSON.parse(
      localStorage.getItem("authTokens") || "{}",
    );
    const userId = authTokens.user?.id;

    try {
      setLoader(true);
      const payload = {
        user_id: userId,
      };

      const response: any = await getVehicleList(payload);
      const vehicleData = response?.data?.map((vehicle: any) => ({
        id: vehicle.id,
        color: vehicle.vehicle_color || "N/A",
        name:
          `${vehicle?.make?.name} ${vehicle?.model?.name} ${vehicle?.variant?.name}` ||
          "Name Not Available",
        licensePlate: vehicle.vehicle_number,
        imageUrl: vehicleText,
        make: vehicle?.make?.name,
        model: vehicle?.model?.name,
        variant: vehicle?.variant?.name,
        variantId: vehicle?.variant?.predefined_id,

        category: vehicle?.category,
      }));
      // const vehicleData = response?.data?.map((vehicle: any) => ({
      //   id: vehicle.id,
      //   color: vehicle.vehicle_color || "N/A",
      //   name:
      //     `${vehicle?.make?.name} ${vehicle?.model?.name} ${vehicle?.variant?.name}` ||
      //     "Name Not Available",
      //   licensePlate: vehicle.vehicle_number,
      //   imageUrl: vehicleText,
      //   make: vehicle?.make?.name,
      //   model: vehicle?.model?.name,
      //   variant: vehicle?.variant?.name,
      //   variantId: vehicle?.variant?.predefined_id,
      // }));
      // setCars(vehicleData || null);
      setCars(vehicleData || []);

      if (vehicleData?.length > 0) {
        setSelectedCarId(vehicleData[0].id);
      }
    } catch (error) {
      console.error("Error fetching vehicles:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchCartProducts();
    fetchAddress();
    fetchCartSummary();
    fetchVehicleList();
    fetchPredefinedList();
  }, []);

  const handleAddMoreItems = (e: any) => {
    e.preventDefault();
    navigate(`${basePath}products`);
  };

  const handleRemoveItem = async (e: any, item: any) => {
    e.preventDefault();
    const response: any = await cartRemoveItem(item?.cartItemId);
    if (response.status === 200 || response.status === 201) {
      await fetchCartProducts();
      await fetchCartSummary();
    }
  };

  const handleSelectCar = (carId: any) => {
    setSelectedCarId(carId.id);
  };

  const handleAddCar = async () => {
    if (!category || !model || !make || !variant) {
      setSubmitted(true);
      return;
    }

    const payload = {
      vehicle_name: vehicleName,
      vehicle_number: vehicleNumber,
      category_id: category,
      model_id: model,
      make_id: make,
      variant_id: variant,
    };

    const formData = new FormData();

    formData.append("data", JSON.stringify(payload));

    const response = await saveVehicle(formData);

    if (response.status === 200 || response.status === 201) {
      fetchVehicleList();
      setVisible(false);
      return toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: `Vehicle Added Successfully`,
      });
    }
  };

  const handleCancel = () => {
    setVisible(false);
    setVehicleName(null);
    setVehicleNumber(null);
    setCategory(null);
    setModel(null);
    setMake(null);
    setVariant(null);
    setTypeId(null);
    setSubmitted(false);
    setIsChangingBillingAddress(false);
    setNewBillingAddress(null);
    setNewShippingAddress(null);
    setIsChangingAddress(false);
    setAddress({
      detail_address: "",
      street_address: "",
      landmark: "",
      pincode: "",
    });
    setSelectedCity(null);
    setSelectedState(null);
    setIsDefaultAddress(null);
  };

  const handleNewAddressChange = async () => {
    if (newShippingAddress || newBillingAddress) {
      if (newBillingAddress) {
        const newAddress = billingAddresses.find(
          (address: any) => address?.address_id === newBillingAddress,
        );
        setBillingAddressesState(newAddress);
        handleCancel();
      } else {
        const newAddress = shippingAddresses.find(
          (address: any) => address?.address_id === newShippingAddress,
        );
        setShippingAddressesState(newAddress);
        handleCancel();
      }
      return;
    }

    if (
      address.detail_address === "" ||
      address.street_address === "" ||
      address.landmark === "" ||
      address.pincode === "" ||
      !selectedCity ||
      !selectedState
    ) {
      setSubmitted(true);
      return;
    }

    const payload = {
      detail_address: address?.detail_address,
      street_address: address?.street_address,
      landmark: address?.landmark,
      pincode: address?.pincode,
      entity_type: isChangingBillingAddress ? "BILLING" : "SHIPPING",
      is_default: false,
      city_id: selectedCity,
      state_id: selectedState,
      country_id: selectedCountry,
    };

    const response = await saveUserAddress(payload);
    if (response.status === 200 || response.status === 201) {
      fetchAddress();
      setIsChangingAddress(false);
      setSubmitted(false);
      handleCancel();
      return toast?.current?.show({
        severity: "success",
        summary: "Successful",
        detail: `${response.data.message}`,
      });
    }
  };

  const footerContent = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        onClick={handleCancel}
        className="p-button-text"
      />
      <Button
        label="Submit"
        icon="pi pi-check"
        onClick={handleAddCar}
        autoFocus
        className="add-item"
      />
    </div>
  );

  const footerContent2 = (
    <div>
      <Button label="Cancel" onClick={handleCancel} className="p-button-text" />
      <Button label="Submit" onClick={handleNewAddressChange} autoFocus  className="add-item"/>
    </div>
  );

  const handleProceedApproval = async () => {
    setLoading(true);
    try {
      if (!selectedCarId) {
        return toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `Please Select A vehicle`,
        });
      }

      if (
        userRole?.code === customerRole ||
        userRole?.code === fleetUserOwner ||
        userRole?.code === fleetUserRole
      ) {
        if (!selectedBillingAddress) {
          return toast?.current?.show({
            severity: "error",
            summary: "Failed",
            detail: `Please Select Address`,
          });
        }
      }

      if (
        !userIdState ||
        !servicePointId ||
        !pickedDate ||
        !pickedTime ||
        !selectedCarId
      ) {
        return toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `Failed to Schedule an Appointment`,
        });
      }

      const payload = {
        user_id: userIdState,
        service_point_id: servicePointId,
        service_start_date: formatDateToString(new Date(selectedPickedDate)),
        service_start_time_id: pickedTime?.code,
        shipping_address_id: selectedShippingAddress,
        billing_address_id: selectedBillingAddress,
        vehicle_id: selectedCarId,
        is_use_wallet: useWalletBalance,
        instructions: location?.state?.specialInstructions ?? null,
        code: currentCouponCode,
      };

      const response: any = await scheduleAppointment(payload);

      if (response?.status === 200 || response?.status === 201) {
        const responseData = response?.data?.data || response?.data || {};

        const orderIdValue =
          responseData?.order_id ||
          responseData?.orderId ||
          responseData?.appointment_id ||
          responseData?.appointmentId ||
          responseData?.id ||
          "-";

        const selectedVehicle = cars?.find((car) => car.id === selectedCarId);

        setOrderConfirmationDetails({
          orderId: String(orderIdValue),
          paymentId: responseData?.payment_id || responseData?.paymentId || "-",
          amount: new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(billingDetails?.total) || 0),
          serviceDate: selectedPickedDate
            ? formatDateToString(new Date(selectedPickedDate))
            : "-",
          serviceTime: pickedTime?.name || "-",
          vehicle: selectedVehicle
            ? `${selectedVehicle.make} ${selectedVehicle.model} ${selectedVehicle.variant}`
            : "-",
        });

        setShowOrderConfirmationDialog(true);
        dispatch(resetCart());
        setSelectedServicePoint(null);

        return toast?.current?.show({
          severity: "success",
          summary: "Successful",
          detail: "Order Placed Successfully",
        });
      } else if (response?.response?.status === 400) {
        return toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `${response.response.data.message}`,
        });
      } else {
        return toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `Failed to Schedule an Appointment`,
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const paymentStatus = async (paymentId: any) => {
    const response: any = await getPaymentStatus(paymentId);
    if (response?.status === 200 || response?.status === 201) {
      if (response?.data?.data?.order_status === "FAILED") {
        return toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `Payment Failed`,
        });
      }
      if (response?.data?.data?.order_status === "SUCCESS") {
        toast?.current?.show({
          severity: "success",
          summary: "Successful",
          detail: `Payment Successful`,
        });

        const payload = {
          user_id: userIdState,
          service_point_id: servicePointId,
          service_start_date: formatDateToString(new Date(selectedPickedDate)),
          service_start_time_id: pickedTime?.code,
          shipping_address_id: selectedShippingAddress,
          billing_address_id: selectedBillingAddress,
          vehicle_id: selectedCarId,
          is_use_wallet: useWalletBalance,
          instructions: location?.state?.specialInstructions ?? null,
          code: currentCouponCode,
          payment_id: paymentId,
        };

        const orderSaveResponse: any = await saveOrderAPI(payload);
        if (
          orderSaveResponse?.status === 200 ||
          orderSaveResponse?.status === 201
        ) {
          const responseData =
            orderSaveResponse?.data?.data || orderSaveResponse?.data || {};

          const selectedVehicle = cars?.find((car) => car.id === selectedCarId);

          const orderIdValue =
            responseData?.order_id ||
            responseData?.orderId ||
            responseData?.id ||
            "-";

          const paymentIdValue =
            responseData?.payment_id ||
            responseData?.paymentId ||
            paymentId ||
            "-";

          const amountValue =
            responseData?.amount ??
            responseData?.total ??
            billingDetails?.total ??
            0;

          setOrderConfirmationDetails({
            orderId: String(orderIdValue),
            paymentId: String(paymentIdValue),
            amount: new Intl.NumberFormat("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Number(amountValue) || 0),
            serviceDate: selectedPickedDate
              ? formatDateToString(new Date(selectedPickedDate))
              : "-",
            serviceTime: pickedTime?.name || "-",
            vehicle: selectedVehicle
              ? `${selectedVehicle.make} ${selectedVehicle.model} ${selectedVehicle.variant}`
              : "-",
          });

          setShowOrderConfirmationDialog(true);

          dispatch(resetCart());
          setSelectedServicePoint(null);

          return toast?.current?.show({
            severity: "success",
            summary: "Successful",
            detail: "Payment Successful",
          });
        }
      }
    }
  };

  const paymentStatusNew = async (paymentId: any, razorpayPaymentId: any) => {
    try {
      setLoader(true);
      await new Promise<void>((resolve) => {
        let secondsLeft = 5;
        setCountdown(secondsLeft);

        const interval = setInterval(() => {
          secondsLeft -= 1;
          setCountdown(secondsLeft);

          if (secondsLeft <= 0) {
            clearInterval(interval);
            resolve();
          }
        }, 1000);
      });
      const payload = {
        user_id: userIdState,
        service_point_id: servicePointId,
        service_start_date: formatDateToString(new Date(selectedPickedDate)),
        service_start_time_id: pickedTime?.code,
        shipping_address_id: selectedShippingAddress,
        billing_address_id: selectedBillingAddress,
        vehicle_id: selectedCarId,
        is_use_wallet: useWalletBalance,
        instructions: location?.state?.specialInstructions ?? null,
        code: currentCouponCode,
        payment_id: paymentId,
        razorpay_payment_id: razorpayPaymentId,
      };

      const orderSaveResponse: any = await saveOrderAPI(payload);
      if (
        orderSaveResponse?.status === 200 ||
        orderSaveResponse?.status === 201
      ) {
        const responseData =
          orderSaveResponse?.data?.data || orderSaveResponse?.data || {};
        const selectedVehicle = cars?.find((car) => car.id === selectedCarId);
        const orderIdValue =
          responseData?.order_id || responseData?.orderId || responseData?.id;
        const paymentIdValue =
          responseData?.payment_id || responseData?.paymentId || paymentId;
        const amountValue =
          responseData?.amount ??
          responseData?.total ??
          billingDetails?.total ??
          0;

        setOrderConfirmationDetails({
          orderId: orderIdValue ? String(orderIdValue) : "-",
          paymentId: paymentIdValue ? String(paymentIdValue) : "-",
          amount: new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(amountValue) || 0),
          serviceDate: selectedPickedDate
            ? formatDateToString(new Date(selectedPickedDate))
            : "-",
          serviceTime: pickedTime?.name || "-",
          vehicle: selectedVehicle
            ? `${selectedVehicle.make} ${selectedVehicle.model} ${selectedVehicle.variant}`
            : "-",
        });

        setShowOrderConfirmationDialog(true);
        dispatch(updateCartQuantity(0));
        setSelectedServicePoint(null);
        return toast?.current?.show({
          severity: "success",
          summary: "Successful",
          detail: `Payment Successful`,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const handleOrderConfirmationClose = () => {
    setShowOrderConfirmationDialog(false);
    dispatch(resetCart());
    navigate(`${basePath}profile`, {
      state: {
        orderSuccess: true,
        orderId: orderConfirmationDetails.orderId,
      },
    });
  };

  const handlePaymentFunc = async () => {
    setLoading(true);
    try {
      if (!selectedCarId) {
        return toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `Please Select A vehicle`,
        });
      }
      if (!items || items.length === 0) {
        return toast?.current?.show({
          severity: "error",
          summary: "Failed",
          detail: `Please Add Items to Cart`,
        });
      }

      if (
        userRole?.code === customerRole ||
        userRole?.code === fleetUserOwner ||
        userRole?.code === fleetUserRole
      ) {
        if (!selectedBillingAddress) {
          return toast?.current?.show({
            severity: "error",
            summary: "Failed",
            detail: `Please Select Address`,
          });
        }
      }
      if (billingDetails?.total === 0) {
        const payload = {
          user_id: userIdState,
          service_point_id: servicePointId,
          service_start_date: formatDateToString(new Date(selectedPickedDate)),
          service_start_time_id: pickedTime?.code,
          shipping_address_id: selectedShippingAddress,
          billing_address_id: selectedBillingAddress,
          vehicle_id: selectedCarId,
          is_use_wallet: useWalletBalance,
          instructions: location?.state?.specialInstructions ?? null,
          code: currentCouponCode,
          payment_id: paymentId,
        };

        const orderSaveResponse: any = await saveOrderAPI(payload);
        if (
          orderSaveResponse?.status === 200 ||
          orderSaveResponse?.status === 201
        ) {
          const responseData =
            orderSaveResponse?.data?.data || orderSaveResponse?.data || {};

          const selectedVehicle = cars?.find((car) => car.id === selectedCarId);

          setOrderConfirmationDetails({
            orderId: String(
              responseData?.order_id ||
                responseData?.orderId ||
                responseData?.id ||
                "-",
            ),
            paymentId: String(
              responseData?.payment_id || responseData?.paymentId || "-",
            ),
            amount: "0.00",
            serviceDate: selectedPickedDate
              ? formatDateToString(new Date(selectedPickedDate))
              : "-",
            serviceTime: pickedTime?.name || "-",
            vehicle: selectedVehicle
              ? `${selectedVehicle.make} ${selectedVehicle.model} ${selectedVehicle.variant}`
              : "-",
          });

          setShowOrderConfirmationDialog(true);
          dispatch(resetCart());
          setSelectedServicePoint(null);

          return toast?.current?.show({
            severity: "success",
            summary: "Successful",
            detail: "Order Placed Successfully",
          });
        } else {
          return toast?.current?.show({
            severity: "error",
            summary: "Failed",
            detail: `Payment Failed`,
          });
        }
      }

      const payload = {
        user_id: userIdState,
        amount: billingDetails?.total,
        is_wallet: useWalletBalance,
        service_point_id: servicePointId,
        service_start_date: formatDateToString(new Date(selectedPickedDate)),
        service_start_time_id: pickedTime?.code,
        shipping_address_id: selectedShippingAddress,
        billing_address_id: selectedBillingAddress,
        vehicle_id: selectedCarId,
        is_use_wallet: useWalletBalance,
        instructions: location?.state?.specialInstructions ?? null,
        code: currentCouponCode,
      };
      const response: any = await getPaymentLink(payload);
      setMakePaymentObject(response?.data);
      setPaymentId(response?.data?.payment_id);
      openRazorpayCheckout(response?.data);
    } catch (err: any) {
      if (err.status === 200) {
        let jsonString = err.error.text;
        jsonString = jsonString.substr(0, jsonString.indexOf('{"timestamp"'));
      }
    } finally {
      setLoading(false);
    }
  };

  const openRazorpayCheckout = (orderData: any) => {
    const authTokens = JSON.parse(localStorage.getItem("authTokens") || "{}");
    const options = {
      key: orderData.key,
      amount: orderData.amount,
      currency: orderData.currency || "INR",
      name: "Junction Of Tyres",
      description: `${orderData?.id}`,
      image: "https://mechmiles.com/favicon.ico",
      order_id: orderData.id,
      prefill: {
        name: authTokens?.user?.full_name,
        email: authTokens?.user?.email,
        contact: authTokens?.user?.username,
      },
      theme: {
        color: "#642088",
      },
      handler: async function (response: any) {
        try {
          await paymentStatusNew(
            orderData.payment_id,
            response.razorpay_payment_id,
          );
        } catch (error) {
          console.error("paymentStatusNew error:", error);
        }
      },
      modal: {
        ondismiss: function () {},
      },
    };

    const razorpay = new window.Razorpay(options);

    razorpay.on("payment.failed", function (response: any) {
      toast?.current?.show({
        severity: "error",
        summary: "Payment Failed",
        detail: response.error.description,
      });
    });

    razorpay.open();
  };

  const handleBillingAddressChange = () => {
    setIsChangingAddress(true);
    setIsChangingBillingAddress(true);
  };
  const handleShippingAddressChange = () => {
    setIsChangingAddress(true);
    setIsChangingBillingAddress(false);
  };

  const onInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    name: string,
  ) => {
    const { value } = e.target;
    if (name === "pincode" && isNaN(Number(value))) {
      return;
    }

    if (name === "pincode") {
      if (!/^\d{6}$/.test(value)) {
        setPincodeError("Pincode must be a 6-digit number");
      } else {
        setPincodeError("");
      }
    }
    setAddress((prevAddress) => ({
      ...prevAddress,
      [name]: value,
    }));
  };

  const handleNewAddress = (e: any) => {
    if (isChangingBillingAddress) {
      setNewBillingAddress(e.value);
    } else {
      setNewShippingAddress(e.value);
    }
  };

  const handleNewBillingAddress = () => {
    setIsChangingAddress(true);
    setIsChangingBillingAddress(true);
  };
  const handleNewShippingAddress = () => {
    setIsChangingAddress(true);
    setIsChangingBillingAddress(false);
  };

  const handleBillingAddressSelection = (addressId: any) => {
    setSelectedBillingAddress(addressId);
  };
  const handleShippingAddressSelection = (addressId: any) => {
    setSelectedShippingAddress(addressId);
  };

  const redirectToCart = () => {
    navigate("/cart");
  };

  // const fetchAllCouponFunc = async () => {
  //   const payload = {};

  //   const response: any = await getCouponList(payload);

  //   if (response.status === 200) {
  //     setAllCouponList(response.data);
  //     setShowCouponDialog(true);
  //   }
  // };
  const fetchAllCouponFunc = async () => {
    const payload = {
      flag:"website"
    };

    const response: any = await getCouponList(payload);

    if (response.status === 200) {
      setAllCouponList(
        Array.isArray(response.data)
          ? response.data.filter((coupon: any) => coupon?.code || coupon?.name)
          : [],
      );

      setShowCouponDialog(true);
    }
  };
  const useWalletBalanceFunc = async (e: any) => {
    const isUsingWallet = e.checked === true ? true : null;
    const response: any = await cartSummery(
      currentCouponCode ?? "",
      isUsingWallet,
    );

    if (response?.response?.status === 400) {
      setCurrentCouponCode("");
      return toast?.current?.show({
        severity: "error",
        summary: "Failed",
        detail: `${response?.response?.data?.error}`,
      });
    }

    if (response.status === 200) {
      setBillingDetails(response?.data);
      setShowCouponDialog(false);
      setUseWalletBalance(e.checked);
    }
  };

  return (
    <div className="summery-wrapper">
      <Toast ref={toast} />
      <div className="summery-header-wrapper">
        <Container>
          <BreadCrumbs />
          <div className="summery-title" style={{ color: "#642088" }}>
            Summary
          </div>
        </Container>
      </div>
      <Container>
        <div className="summary-layout">
          {/* ============== MAIN (LEFT) COLUMN ============== */}
          <div className="summary-main">
            <div className="summary-container">
              <div className="item-listing-wrapper">
                <div className="items-container1">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div className="billing-details-title">
                      <span>Items</span>
                    </div>
                    <div>
                      <Button className="add-item" onClick={handleAddMoreItems}>
                        + Add more items
                      </Button>
                    </div>
                  </div>
                  {loader ? (
                    <AppSkeleton
                      count={4}
                      width="550px"
                      height="100px"
                      borderRadius="12px"
                      containerClassName="popular-brands-skeleton-grid"
                      className="popular-brands-skeleton-item"
                    />
                  ) : (
                    // <ul className="item-list1">
                    //   {items?.length === 0 && (
                    //     <div
                    //       style={{
                    //         display: "flex",
                    //         flexDirection: "column",
                    //         alignItems: "center",
                    //       }}
                    //     >
                    //       <Image
                    //         src={noProductFoundImage}
                    //         alt="No Product Found"
                    //         width="200"
                    //         height="200"
                    //         className="no-products-image"
                    //       />

                    //       <div className="no-items">No Item Available</div>
                    //     </div>
                    //   )}

                    //   {items?.map((item: any, index: any) => (
                    //     <li key={item.id} className="item">
                    //       <div className="item-title-wrapper">
                    //         <Image
                    //           src={
                    //             item?.brandImage ||
                    //             "https://mechmiles.com/not-available.png"
                    //           }
                    //           alt="Logo"
                    //           className="item-title-image"
                    //         />
                    //         {/* <Image
                    //           src={
                    //             item?.product?.document_as_product?.[0]
                    //               ?.document?.file_path
                    //           }
                    //           alt="Product"
                    //           className="item-title-image"
                    //         /> */}
                    //         <div className="item-index">
                    //           {/* <strong>{index + 1})</strong> */}
                    //         </div>
                    //         <div
                    //           style={{
                    //             display: "flex",
                    //             flexDirection: "column",
                    //           }}
                    //         >
                    //           <div className="item-title-container">
                    //             <div className="item-name1">{item.name}</div>
                    //           </div>
                    //         </div>
                    //       </div>
                    //       {/* <Image
                    //         src={miniDot}
                    //         alt="Mini Dot"
                    //         className="item-dot"
                    //       /> */}
                    //       {!hideWalletAndCoupon && (
                    //         <>
                    //           <div className="item-details">
                    //             &#8377; {item.prodPrice}
                    //           </div>
                    //           <Image
                    //             src={miniDot}
                    //             alt="Mini Dot"
                    //             className="item-dot"
                    //           />
                    //         </>
                    //       )}
                    //       <div className="item-quantity">
                    //         Quantity: {item.quantity}
                    //       </div>
                    //       <button
                    //         className="item-remove"
                    //         onClick={(e: any) => handleRemoveItem(e, item)}
                    //       >
                    //         x
                    //       </button>
                    //     </li>
                    //   ))}
                    // </ul>
                    <ul className="item-list1">
                      {items?.length === 0 && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Image
                            src={noProductFoundImage}
                            alt="No Product Found"
                            width="200"
                            height="200"
                            className="no-products-image"
                          />
                          <div className="no-items">No Item Available</div>
                        </div>
                      )}

                      {items?.map((item: any) => (
                        <li key={item.id} className="item-card">
                          {/* Thumbnail */}
                          <div className="item-card-thumb">
                            <Image
                              src={
                                item?.brandImage ||
                                "https://mechmiles.com/not-available.png"
                              }
                              alt={item.name}
                              className="item-card-img"
                            />
                          </div>

                          {/* Name + price */}
                          <div className="item-card-info">
                            <div className="item-card-name" title={item.name}>
                              {item.name}
                            </div>
                            {!hideWalletAndCoupon && (
                              <div className="item-card-price">
                                &#8377; {item.prodPrice}
                              </div>
                            )}
                          </div>

                          {/* Quantity */}
                          <div className="item-card-qty">
                            Qty: {item.quantity}
                          </div>

                          {/* Remove */}
                          <button
                            type="button"
                            className="item-card-remove"
                            aria-label="Remove item"
                            onClick={(e: any) => handleRemoveItem(e, item)}
                          >
                            <IoClose />
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>

            {loader ? (
              <AppSkeleton
                count={6}
                width="550px"
                height="100px"
                borderRadius="12px"
                containerClassName="popular-brands-skeleton-grid"
                className="popular-brands-skeleton-item"
              />
            ) : (
              <div className="select-car-container">
                <div className="select-car-wrapper">
                  {/* ===== UI FIX: proper order — title, then subtitle below it, button aligned top-right ===== */}
                  <div className="select-car-header-row">
                    <div className="select-car-header-text">
                      <div className="select-car-header billing-details-title">
                        Select Vehicle <span className="error">*</span>
                      </div>
                      <p className="select-car-subtitle">
                        Please select a Vehicle
                      </p>
                    </div>
                    <div>
                      <Button
                        className="add-item"
                        onClick={() => setVisible(true)}
                      >
                        + Add New Vehicle
                      </Button>
                    </div>
                  </div>

                  {loader ? (
                    <AppSkeleton
                      count={5}
                      width="250px"
                      height="200px"
                      borderRadius="12px"
                      containerClassName="popular-brands-skeleton-grid"
                      className="popular-brands-skeleton-item"
                    />
                  ) : (
                    <>
                      {" "}
                      <div className="car-list">
                        {cars?.length === 0 ? (
                          <div className="no-items">No Car Available</div>
                        ) : (
                          cars?.map((car) => (
                            <div
                              key={car.id}
                              className={`car-list-item ${
                                selectedCarId === car.id ? "selected-car" : ""
                              }`}
                              onClick={() => handleSelectCar(car)}
                            >
                              <div className="car-list-image">
                                {getVehicleIcon(car?.category?.name)}
                              </div>

                              <div className="car-list-data">
                                <div className="vehicle-make">{car?.make}</div>

                                <div className="vehicle-model">
                                  {car?.model}
                                </div>
                                <p className="vehicle-number">
                                  {car?.licensePlate?.toUpperCase()}
                                </p>
                              </div>

                              {selectedCarId === car?.id && (
                                <div className="check-icon-wrapper">
                                  <Image
                                    src={checkIcon}
                                    alt="Selected"
                                    height="26px"
                                    width="26px"
                                  />
                                </div>
                              )}
                            </div>
                          ))
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

            {(userRole.code === fleetUserRole ||
              userRole.code === customerRole ||
              userRole.code === fleetUserOwner) && (
              <div className="select-car-container">
                {loader ? (
                  <AppSkeleton
                    count={2}
                    width="550px"
                    height="100px"
                    borderRadius="12px"
                    containerClassName="popular-brands-skeleton-grid"
                    className="popular-brands-skeleton-item"
                  />
                ) : (
                  <div className="select-car-wrapper">
                    <div className="billing-address-wrapper">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                         <div className="select-car-header-text">
                      <div className="billing-details-title">
                        Select Billing Address <span className="error">*</span>
                      </div>
                      <p className="select-car-subtitle">
                        Please select a Billing Address
                      </p>
                    </div>
                        
                        <div>
                          <Button
                            className="add-item"
                            onClick={handleNewBillingAddress}
                          >
                            + Add New Address
                          </Button>
                        </div>
                      </div>
                      <div className="billing-addresses-container">
                        <div className="billing-addresses-list-wrapper">
                          {billingAddresses?.length > 0 ? (
                            billingAddresses.map((address: any) => (
                              <div
                                key={address?.address_id}
                                className={`billing-address-card ${
                                  selectedBillingAddress === address?.address_id
                                    ? "selected-address"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleBillingAddressSelection(
                                    address?.address_id,
                                  )
                                }
                              >
                                <div className="billing-address-data">
                                  <div
                                    className="billing-address-text"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {`${address?.detail_address}, ${address?.street_address}, ${address?.landmark}`}
                                  </div>

                                  <div
                                    className="billing-address-location"
                                    style={{ fontSize: "12px" }}
                                  >
                                    {`${address?.city?.name} - ${address?.pincode}`}
                                  </div>
                                </div>

                                {selectedBillingAddress ===
                                  address?.address_id && (
                                  <div className="check-icon-wrapper">
                                    <Image
                                      src={checkIcon}
                                      alt="Selected"
                                      height="26px"
                                      width="26px"
                                    />
                                  </div>
                                )}
                              </div>
                            ))
                          ) : (
                            <div className="no-address-card">
                              No address available
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {userRole.code !== customerRole && (
                      <div className="shipping-address-wrapper">
                        <div className="shipping-address title">
                          Shipping Address
                        </div>
                        <div className="billing-addresses-container">
                          <div className="billing-addresses-list-wrapper">
                            {shippingAddresses?.length > 0 ? (
                              shippingAddresses?.map((address: any) => (
                                <div
                                  key={address?.address_id}
                                  className={`billing-address-card ${
                                    selectedShippingAddress ===
                                    address?.address_id
                                      ? "selected-address"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    handleShippingAddressSelection(
                                      address?.address_id,
                                    )
                                  }
                                >
                                  <div
                                    className="billing-address-data"
                                    style={{ fontSize: "11px" }}
                                  >
                                    <div
                                      className="billing-address-text"
                                      style={{ fontSize: "11px" }}
                                    >
                                      {`${address?.detail_address}, ${address?.street_address}, ${address?.landmark}`}
                                    </div>

                                    <div
                                      className="billing-address-location"
                                      style={{ fontSize: "11px" }}
                                    >
                                      {`${address?.city?.name} - ${address?.pincode}`}
                                    </div>
                                  </div>

                                  {selectedShippingAddress ===
                                    address?.address_id && (
                                    <div className="check-icon-wrapper">
                                      <Image
                                        src={checkIcon}
                                        alt="Selected"
                                        height="26px"
                                        width="26px"
                                      />
                                    </div>
                                  )}
                                </div>
                              ))
                            ) : (
                              <div className="no-address-card">
                                No address available
                              </div>
                            )}
                          </div>
                          <Button
                            className="add-new-address-button"
                            onClick={handleNewShippingAddress}
                          >
                            <FaPlus /> Add New Address
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ============== SIDEBAR (RIGHT) COLUMN ============== */}
          <div className="summary-sidebar">
            <div className="service-point-summary-card">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="service-point-summary-title">Service Point</div>
                <div>
                  <p
                    className="change-location-link cursor-pointer"
                    onClick={redirectToCart}
                  >
                    <MdEdit />
                  </p>
                </div>
              </div>
              <div className="service-point-summary-body">
                <div className="service-point-summary-name">
                  {selectedServicePoint?.service_point_name}
                </div>
                <div className="service-point-summary-address">
                  {selectedServicePoint?.service_point_address}
                </div>
                <div className="service-point-summary-time">
                  <IoCalendarOutline />
                  <span>
                    {`${pickedDate}`} ({pickedTime?.name})
                  </span>
                </div>
              </div>
            </div>

            {!hideWalletAndCoupon && (
              <div className="billing-summary-card">
                <div className="billing-summary-header">
                  <div className="billing-details-title">Order Summary</div>
                  <Button
                    className="view-coupons-btn"
                    onClick={fetchAllCouponFunc}
                  >
                    Apply Coupon
                  </Button>
                </div>

                {loader ? (
                  <AppSkeleton
                    count={1}
                    width="100%"
                    height="50px"
                    borderRadius="12px"
                    containerClassName="popular-brands-skeleton-grid"
                    className="popular-brands-skeleton-item"
                  />
                ) : (
                  <div className="billing-details-content">
                    <div className="billing-detail">
                      <span
                        className="billing-detail-label "
                        style={{ fontSize: "15px" }}
                      >
                        Subtotal
                      </span>
                      <span>
                        &#8377;{" "}
                        {new Intl.NumberFormat("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(billingDetails?.product_total?.toFixed(2) ?? 0)}
                      </span>
                    </div>
                    {/* <div className="billing-detail">
                      <span
                        className="billing-detail-label"
                        style={{ fontSize: "15px" }}
                      >
                        GST
                      </span>
                      <span>
                        &#8377;{" "}
                        {new Intl.NumberFormat("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }).format(billingDetails?.gst?.toFixed(2) ?? 0)}
                      </span>
                    </div> */}
                    {billingDetails?.additional_charges_summary?.FITMENT !==
                      undefined &&
                      billingDetails?.additional_charges_summary?.FITMENT !==
                        null && (
                        <div className="billing-detail">
                          <span
                            className="billing-detail-label"
                            style={{ fontSize: "15px" }}
                          >
                            <span
                              className="summary-tooltip-label"
                              data-pr-tooltip={
                                billingDetails?.additional_charges_summary
                                  ?.FITMENT_DESC || ""
                              }
                              // data-pr-tooltip="Fitment charges are applicable for the selected service."
                            >
                              Fitment
                              <i className="pi pi-info-circle summary-info-icon" />
                            </span>

                            <Tooltip target=".summary-tooltip-label" />
                          </span>

                          <span>
                            {/* Original FITMENT price */}
                            {billingDetails?.additional_charges_summary
                              ?.ORGINAL_FITMENT >
                              billingDetails?.additional_charges_summary
                                ?.FITMENT && (
                              <span className="original-platform-charge">
                                ₹{" "}
                                {Number(
                                  billingDetails?.additional_charges_summary
                                    ?.ORGINAL_FITMENT ?? 0,
                                ).toFixed(2)}
                              </span>
                            )}
                            ₹
                            {Number(
                              billingDetails?.additional_charges_summary
                                ?.FITMENT ?? 0,
                            ).toFixed(2)}
                          </span>
                        </div>
                      )}
                    {billingDetails?.additional_charges_summary
                      ?.PLATFORM_CHARGE !== undefined &&
                      billingDetails?.additional_charges_summary
                        ?.PLATFORM_CHARGE !== null && (
                        <div className="billing-detail">
                          <span
                            className="billing-detail-label"
                            style={{ fontSize: "15px" }}
                          >
                            <span
                              className="platform-charge-tooltip"
                              data-pr-tooltip={
                                billingDetails?.additional_charges_summary
                                  ?.PLATFORM_CHARGE_DESC || ""
                              }
                              // data-pr-tooltip="Platform charge applied to this order."
                            >
                              Platform Charge
                              <i className="pi pi-info-circle summary-info-icon" />
                            </span>

                            <Tooltip target=".platform-charge-tooltip" />
                          </span>

                          <span className="platform-charge-value">
                            {/* Original Platform Charge */}
                            {billingDetails?.additional_charges_summary
                              ?.ORGINAL_PLATFORM_CHARGE >
                              billingDetails?.additional_charges_summary
                                ?.PLATFORM_CHARGE && (
                              <span className="original-platform-charge">
                                ₹{" "}
                                {Number(
                                  billingDetails?.additional_charges_summary
                                    ?.ORGINAL_PLATFORM_CHARGE ?? 0,
                                ).toFixed(2)}
                              </span>
                            )}
                            {/* Final Platform Charge */}₹{" "}
                            {Number(
                              billingDetails?.additional_charges_summary
                                ?.PLATFORM_CHARGE ?? 0,
                            ).toFixed(2)}
                          </span>
                        </div>
                      )}
                    {useWalletBalance && (
                      <div className="billing-detail">
                        <span className="billing-detail-label">
                          Wallet Discount
                        </span>
                        <span
                          className={`billing-detail-amount ${
                            useWalletBalance ? "discount" : ""
                          }`}
                        >
                          &#8377;{" "}
                          {new Intl.NumberFormat("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(
                            billingDetails?.wallet_discount?.toFixed(2) ?? 0,
                          )}
                        </span>
                      </div>
                    )}
                    {useDiscountCode && (
                      <div className="billing-detail">
                        <span
                          className="billing-detail-label"
                          style={{ fontSize: "15px" }}
                        >
                          Discount
                        </span>
                        <span
                          className={`billing-detail-amount ${
                            useDiscountCode ? "discount" : ""
                          }`}
                        >
                          -&#8377;{" "}
                          {new Intl.NumberFormat("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }).format(billingDetails?.discount?.toFixed(2) ?? 0)}
                        </span>
                      </div>
                    )}
                  </div>
                )}
                <div className="billing-detail">
                  <strong>
                    <span className="billing-detail-label">Total</span>
                  </strong>
                  <strong>
                    <span>
                      &#8377;{" "}
                      {new Intl.NumberFormat("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(billingDetails?.total?.toFixed(2) ?? 0)}
                    </span>
                  </strong>
                </div>
              </div>
            )}

            <div>
              <Button
                className="proceed-for-approval-btn sidebar-proceed-btn"
                loading={loading}
                disabled={loading}
                onClick={
                  hideWalletAndCoupon
                    ? handleProceedApproval
                    : handlePaymentFunc
                }
              >
                {hideWalletAndCoupon
                  ? "Proceed for Approval"
                  : "Proceed to Pay"}
              </Button>
            </div>
          </div>
        </div>
      </Container>

      <Dialog
        header="Add New Vehicle"
        footer={footerContent}
        visible={visible}
        onHide={() => setVisible(false)}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90%" }}
      >
        <div className="add-new-car-wrapper grid">
          <div className="field col-6 vehicle-number">
            <label htmlFor="vehicle-number">Vehicle Number</label>
            <InputText
              className="w-full"
              value={vehicleNumber}
              onChange={(e) => setVehicleNumber(e.target.value)}
              placeholder="Vehicle Number"
              id="vehicle-number"
            />
          </div>
          <div className="field col-12 vehicle-category">
            <label>
              Category <span className="error">*</span>
            </label>
            <Dropdown
              className="w-full"
              value={category}
              options={categories}
              onChange={(e) => setCategory(e.value)}
              placeholder="Select a Category"
              optionValue="code"
              optionLabel="name"
              showClear
            />
            {submitted && !category && (
              <small className="error">Category is Required</small>
            )}
          </div>
          <div className="field col-6 vehicle-make">
            <label>
              Make <span className="error">*</span>
            </label>
            <Dropdown
              className="w-full"
              value={make}
              options={makes}
              onChange={(e) => setMake(e.value)}
              placeholder="Select a Make"
              optionValue="code"
              optionLabel="name"
              filter
            />
            {submitted && !make && (
              <small className="error">Make is Required</small>
            )}
          </div>
          <div className="field col-6 vehicle-model">
            <label>
              Model <span className="error">*</span>
            </label>
            <Dropdown
              className="w-full"
              filter
              value={model}
              options={models}
              onChange={(e) => setModel(e.value)}
              placeholder="Select a Model"
              optionValue="code"
              optionLabel="name"
              showClear
            />
            {submitted && !model && (
              <small className="error">Model is Required</small>
            )}
          </div>
          <div className="field col-6 vehicle-variant">
            <label>
              Variant <span className="error">*</span>
            </label>
            <Dropdown
              className="w-full"
              value={variant}
              options={variants}
              onChange={(e) => setVariant(e.value)}
              placeholder="Select a Variant"
              optionValue="code"
              optionLabel="name"
            />
            {submitted && !variant && (
              <small className="error">Variant is Required</small>
            )}
          </div>
        </div>
      </Dialog>

      <Dialog
        header={
          isChangingBillingAddress
            ? "Add Billing Address"
            : "Add Shipping Address"
        }
        footer={footerContent2}
        visible={isChangingAddress}
        onHide={handleCancel}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "90%" }}
      >
        <div className="address-dialog-wrapper">
          <div className="grid">
            <div className="field col-6">
              <label htmlFor="detail_address">
                Address Line 1 <span className="error">*</span>
              </label>
              <InputText
                className="w-full"
                id="detail_address"
                type="text"
                value={address?.detail_address}
                onChange={(e) => onInputChange(e, "detail_address")}
                placeholder="Address Line 1"
                disabled={newBillingAddress || newShippingAddress}
              />
              {submitted && address?.detail_address === "" && (
                <small className="error">Address Line 1 is Required</small>
              )}
            </div>
            <div className="field col-6">
              <label htmlFor="street_address">
                Address Line 2 <span className="error">*</span>
              </label>
              <InputText
                className="w-full"
                id="street_address"
                type="text"
                value={address?.street_address}
                onChange={(e) => onInputChange(e, "street_address")}
                placeholder="Address Line 2"
                disabled={newBillingAddress || newShippingAddress}
              />
              {submitted && address?.street_address === "" && (
                <small className="error">Address Line 2 is Required</small>
              )}
            </div>
            <div className="field col-6">
              <label htmlFor="landmark">
                Landmark <span className="error">*</span>
              </label>
              <InputText
                className="w-full"
                id="landmark"
                type="text"
                value={address?.landmark}
                onChange={(e) => onInputChange(e, "landmark")}
                placeholder="Landmark"
                disabled={newBillingAddress || newShippingAddress}
              />
              {submitted && address?.landmark === "" && (
                <small className="error">Landmark is Required</small>
              )}
            </div>
            <div className="field col-6">
              <label htmlFor="pincode">
                Pincode <span className="error">*</span>
              </label>
              <InputText
                className="w-full"
                id="pincode"
                type="text"
                value={address?.pincode}
                onChange={(e) => onInputChange(e, "pincode")}
                placeholder="Pincode"
                maxLength={6}
                disabled={newBillingAddress || newShippingAddress}
              />
              {submitted && address?.pincode === "" && (
                <small className="error">Pincode is Required</small>
              )}
              {pincodeError && <small className="error">{pincodeError}</small>}
            </div>

            <div className="field col-6">
              <label htmlFor="city">
                State <span className="error">*</span>
              </label>
              <Dropdown
                className="w-full"
                value={selectedState}
                options={stateOptions}
                onChange={(e) => setSelectedState(e.value)}
                placeholder="Select a State"
                optionValue="code"
                optionLabel="name"
                showClear
                disabled={newBillingAddress || newShippingAddress}
                virtualScrollerOptions={{ itemSize: 38 }}
                filter
              />
              {submitted && !selectedState && (
                <small className="error">State is Required</small>
              )}
            </div>
            <div className="field col-6">
              <label htmlFor="city">
                City <span className="error">*</span>
              </label>
              <Dropdown
                className="w-full"
                value={selectedCity}
                options={cityOptions}
                onChange={(e) => setSelectedCity(e.value)}
                placeholder="Select a City"
                optionValue="code"
                optionLabel="name"
                showClear
                disabled={!selectedState}
                virtualScrollerOptions={{ itemSize: 38 }}
                filter
              />
              {submitted && !selectedCity && (
                <small className="error">City is Required</small>
              )}
            </div>

            <div className="field col-6" style={{ display: 'none' }}>
              <label htmlFor="city">
                Country <span className="error">*</span>
              </label>
              <Dropdown
                className="w-full"
                value={22}
                options={countryOptions}
                onChange={(e) => setSelectedCountry(e.value || 22)}
                placeholder="Select a Country"
                optionValue="code"
                optionLabel="name"
                showClear
                disabled
                virtualScrollerOptions={{ itemSize: 38 }}
                filter
              />
            </div>
          </div>
        </div>
      </Dialog>

      {/* ============== COUPON DIALOG (restyled) ============== */}
      {/* <Dialog
        header={
          <div className="coupon-dialog-header">
            <span className="coupon-dialog-icon">%</span>
            <span>Available Coupons</span>
          </div>
        }
        visible={showCouponDialog}
        style={{ width: "40vw" }}
        breakpoints={{ "960px": "90vw" }}
        onHide={() => setShowCouponDialog(false)}
      >
        <div className="coupon-list-wrapper-v2">
          
          <div className="promo-input-row">
            <InputText
              className="promo-input"
              placeholder="Enter code"
              value={currentCouponCode}
              onChange={(e) => setCurrentCouponCode(e.target.value)}
            />
            <span className="promo-apply-link" onClick={fetchCartSummary}>
              APPLY
            </span>
          </div>

          <div className="coupon-cards-scroll">
            {allCouponList.length === 0 && (
              <div className="no-address-card">No coupons available</div>
            )}
            {allCouponList.map((coupon: any, idx: number) => (
              <div className="coupon-card-v2" key={coupon?.code ?? idx}>
                <div className="coupon-ribbon">
                  <span>{coupon?.sub_title ?? coupon?.code ?? "OFF"}</span>
                </div>
                <div className="coupon-card-v2-body">
                  <div className="coupon-card-v2-top">
                    <div className="coupon-card-v2-code">
                      {coupon?.code ?? coupon?.name}
                    </div>
                    <span
                      className="coupon-card-v2-apply"
                      onClick={() => setCurrentCouponCode(coupon.code)}
                    >
                      APPLY
                    </span>
                  </div>
                  <div className="coupon-card-v2-title">
                    {coupon?.name ?? "Coupon"}
                  </div>
                  <div className="coupon-card-v2-desc">
                    {coupon?.description ?? "Description Not Available"}
                  </div>
                  <div className="coupon-card-v2-tc">*T&amp;C Apply</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Dialog> */}
      {/* ============== COUPON DIALOG ============== */}
      <Dialog
        className="coupon-dialog"
        header={
          <div className="coupon-dialog-header">
            <div className="coupon-dialog-title">
              {/* <span
                className="coupon-dialog-back"
                onClick={() => setShowCouponDialog(false)}
              >
                ←
              </span> */}

              <span>Apply Coupon</span>
            </div>

            <span className="coupon-offer-count">
              {allCouponList?.length ?? 0} Offers
            </span>
          </div>
        }
        visible={showCouponDialog}
        style={{
          width: "600px",
          maxWidth: "95vw",
        }}
        breakpoints={{
          "960px": "80vw",
          "768px": "90vw",
          "480px": "96vw",
        }}
        onHide={() => setShowCouponDialog(false)}
      >
        <div className="coupon-list-wrapper-v2">
          {/* ================= COUPON CODE INPUT ================= */}
          <div className="promo-input-row">
            <span className="promo-input-icon">🏷</span>

            <InputText
              className="promo-input"
              placeholder="ENTER COUPON CODE"
              value={currentCouponCode}
              onChange={(e) =>
                setCurrentCouponCode(e.target.value.toUpperCase())
              }
            />

            <button
              type="button"
              className="promo-apply-button"
              onClick={fetchCartSummary}
            >
              APPLY
            </button>
          </div>

          {/* ================= AVAILABLE COUPONS HEADER ================= */}
          <div className="available-coupons-header">
            <span>AVAILABLE COUPONS</span>

            {/* <span className="offers-terms">Offers Terms</span> */}
          </div>

          <div className="coupon-cards-scroll" style={{ cursor: "pointer" }}>
            {/* NO COUPONS */}
            {allCouponList?.length === 0 && (
              <div className="no-address-card">No coupons available</div>
            )}

            {/* COUPONS */}
            {allCouponList?.map((coupon: any, idx: number) => {
              const isPercent = coupon?.is_percent === true;

              const discountText = isPercent
                ? `${coupon?.discount ?? 0}% OFF`
                : `₹${coupon?.discount ?? 0} OFF`;

              const maxAmount =
                coupon?.max_amount !== null &&
                coupon?.max_amount !== undefined &&
                Number(coupon?.max_amount) > 0
                  ? Number(coupon.max_amount)
                  : null;

              const minSlab =
                coupon?.min_slab !== null &&
                coupon?.min_slab !== undefined &&
                Number(coupon?.min_slab) > 0
                  ? Number(coupon.min_slab)
                  : null;

              /*
               * Maximum discount:
               *
               * Percentage coupon + max_amount:
               *     Up to ₹250
               *
               * Fixed amount coupon:
               *     Up to ₹300
               *
               * Percentage coupon without max_amount:
               *     Up to 10% OFF
               */
              const maxDiscountText = maxAmount
                ? `Up to ₹${maxAmount}`
                : !isPercent
                  ? `Up to ₹${coupon?.discount ?? 0}`
                  : null;

              return (
                <div
                  className="coupon-card-v2"
                  key={coupon?.code ?? idx}
                  onClick={() => {
                    setCurrentCouponCode(coupon?.code ?? "");
                  }}
                >
                  {/* ================= LEFT RIBBON ================= */}
                  <div className="coupon-ribbon">
                    <span>{coupon?.sub_title ?? coupon?.name ?? "OFFER"}</span>
                  </div>

                  {/* ================= CARD BODY ================= */}
                  <div className="coupon-card-v2-body">
                    {/* ===== NAME + COUPON CODE ===== */}
                    <div className="coupon-card-v2-top">
                      <div className="coupon-card-v2-name">
                        {coupon?.name ?? "Coupon"}
                      </div>

                      <div
                        className="coupon-card-v2-code"
                        style={{
                          border: "1px solid",
                          backgroundColor: "#642088",
                          color: "#FFF",
                          padding: "2px 5px",
                          borderRadius: "4px",
                        }}
                      >
                        {coupon?.code ?? "CODE"}

                        {/* <span className="coupon-copy-icon">▣</span> */}
                      </div>
                    </div>

                    {/* ===== SUB TITLE ===== */}
                    {coupon?.sub_title && (
                      <div className="coupon-card-v2-title">
                        {coupon.sub_title}
                      </div>
                    )}

                    {/* ===== DESCRIPTION ===== */}
                    {coupon?.description && (
                      <div className="coupon-card-v2-desc">
                        {coupon.description}
                      </div>
                    )}

                    {/* ================= COUPON DETAILS ================= */}
                    <div className="coupon-details-grid">
                      {/* DISCOUNT */}
                      <div className="coupon-detail-item">
                        <span className="coupon-detail-label">Discount</span>

                        <span className="coupon-detail-value">
                          {discountText}
                        </span>
                      </div>

                      {/* MAXIMUM DISCOUNT */}
                      {maxDiscountText && (
                        <div className="coupon-detail-item">
                          <span className="coupon-detail-label">
                            Maximum discount
                          </span>

                          <span className="coupon-detail-value">
                            {maxDiscountText}
                          </span>
                        </div>
                      )}

                      {/* MINIMUM PURCHASE */}
                      {minSlab && (
                        <div className="coupon-detail-item">
                          <span className="coupon-detail-label">
                            Minimum purchase
                          </span>

                          <span className="coupon-detail-value">
                            ₹{minSlab}
                          </span>
                        </div>
                      )}

                      {/* VALID TILL */}
                      {coupon?.expiry_date && (
                        <div className="coupon-detail-item">
                          <span className="coupon-detail-label">
                            Valid till
                          </span>

                          <span className="coupon-detail-value">
                            {coupon.expiry_date}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* ================= BOTTOM ROW ================= */}
                    <div className="coupon-bottom-row">
                      {/* ONCE PER USER */}
                      {coupon?.is_unique === true && (
                        <div className="coupon-usage">
                          Applicable once per user
                        </div>
                      )}
                    </div>

                    {/* T&C */}
                    {/* <div className="coupon-card-v2-tc">*T&amp;C Apply</div> */}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>
      <Dialog
        visible={showOrderConfirmationDialog}
        onHide={handleOrderConfirmationClose}
        style={{ width: "32rem" }}
        breakpoints={{ "960px": "70vw", "641px": "95vw" }}
        showHeader={false}
        closable={false}
        className="order-success-dialog"
      >
        <div className="order-success-content">
          <div className="order-success-icon-wrapper">
            <i className="pi pi-check-circle order-success-icon" />
          </div>
          <h3 className="order-success-title">Order Completed</h3>
          <p className="order-success-message">
            Your order has been successfully completed
          </p>
          <Button
            label="View Details"
            className="order-success-cta"
            onClick={handleOrderConfirmationClose}
            autoFocus
          />
        </div>
      </Dialog>
      {loader && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.7)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <span className="payment-loader-spin"></span>

          {countdown > 0 && (
            <div
              style={{
                marginTop: "12px",
                fontSize: "1.5rem",
                fontWeight: 600,
                color: "#642088",
              }}
            >
              {/* {countdown} */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Summary;
